/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GroupId } from '../models/GroupId';
import type { GroupName } from '../models/GroupName';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class UserAssignService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Assign vehicle to the user
     * Assign vehicle to the user, please note: assigning vehicles to the group and then group to a user is preffered way
     * @param userId User ID
     * @param vehicleId Vehicle ID
     * @returns void
     * @throws ApiError
     */
    public userVehicleAssign(
        userId: string,
        vehicleId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/users/{user_id}/assign_vehicle/{vehicle_id}',
            path: {
                'user_id': userId,
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete user's assigned vehicle
     * Delete user's assigned vehicle
     * @param userId User ID
     * @param vehicleId Vehicle ID
     * @returns void
     * @throws ApiError
     */
    public userVehicleDelete(
        userId: string,
        vehicleId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/users/{user_id}/assign_vehicle/{vehicle_id}',
            path: {
                'user_id': userId,
                'vehicle_id': vehicleId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Assign station to the user
     * Assign station to the user, please note: assigning stations to the group and then group to a user is preferred way
     * @param userId User ID
     * @param stationId Station ID
     * @returns void
     * @throws ApiError
     */
    public userStationAssign(
        userId: string,
        stationId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/users/{user_id}/assign_station/{station_id}',
            path: {
                'user_id': userId,
                'station_id': stationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete user's assigned station
     * Delete user's assigned station
     * @param userId User ID
     * @param stationId Station ID
     * @returns void
     * @throws ApiError
     */
    public userStationDelete(
        userId: string,
        stationId: string,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/users/{user_id}/assign_station/{station_id}',
            path: {
                'user_id': userId,
                'station_id': stationId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * Assign group to the user
     * Assign group to the user
     * @param userId User ID
     * @param groupId
     * @returns void
     * @throws ApiError
     */
    public userAssignGroup(
        userId: string,
        groupId: GroupId,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/users/{user_id}/assign_group/{group_id}',
            path: {
                'user_id': userId,
                'group_id': groupId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                409: `Conflict`,
                500: `Server error`,
            },
        });
    }
    /**
     * Delete assigned group
     * Delete assigned group
     * @param userId User ID
     * @param groupId
     * @returns void
     * @throws ApiError
     */
    public userAssignGroupDelete(
        userId: string,
        groupId: GroupId,
    ): Observable<void> {
        return __request(OpenAPI, this.http, {
            method: 'DELETE',
            url: '/users/{user_id}/assign_group/{group_id}',
            path: {
                'user_id': userId,
                'group_id': groupId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                404: `Not found`,
                412: `Precondition error`,
                500: `Server error`,
            },
        });
    }
    /**
     * List user's groups
     * List user's groups
     * @param userId User ID
     * @returns any Available groups
     * @throws ApiError
     */
    public userGroupList(
        userId: string,
    ): Observable<Array<{
        /**
         * Array of subgroups
         */
        groups: Array<Record<string, any>>;
        id: GroupId;
        name: GroupName;
    }>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/users/{user_id}/assign_group/',
            path: {
                'user_id': userId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Not enough rights`,
                500: `Server error`,
            },
        });
    }
}
